import Listings from '../src/Listings/index';
export default Listings;
